import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { TableWrapper } from "App/Component/ui";
import { headCells, STYLE_WMS_PO } from "./helpers";

// import { isNull } from "App/utils/helpers";
import { useDatatables } from "App/hooks";
import { useContext } from "react";
import { FormContext } from "../../context/FormContext";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";

export default function DataReq() {
  const classes = STYLE_WMS_PO();
  const { formData, rowsRekomendasi } = useContext(FormContext);

  return (
    <>
      <RenderTableCell
        rows={rowsRekomendasi}
        classes={classes}
        formData={formData}
      />
    </>
  );
}

const RenderTableCell = ({ rows }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id_item_req",
    orderByRow: ["id_item_req"],
  });
  return (
    <TableWrapper
      title="DAFTAR REQUEST LOGISTIK"
      withSearch={true}
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      // type="CUSTOM"
      setRowsPerPage={setRowsPerPage}
      withPadding={true}
      className={"mt-2"}
    >
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow
              hover
              tabIndex={-1}
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
              }}
            >
              <TableCell
                component="th"
                scope="row"
                padding="none"
                align="center"
              >
                {index + 1}
              </TableCell>
              <TableCell align="left">{row?.nama}</TableCell>
              <TableCell align="left">{row?.satuan}</TableCell>
              <TableCell align="left">{row.qty}</TableCell>
              {/* <TableCell align="left">{row?.namagolongan}</TableCell> */}
              {/* <TableCell align="left">
                {isNull(row?.remark) ? "-" : row?.remark}
              </TableCell> */}
            </TableRow>
          );
        })}
    </TableWrapper>
  );
};
